import React from "react";

function Address() {
  return (
    <>
      <div className="p-4 h-fit">
        <div className="flex gap-1 bg-gradient-to-r from-yellow-200 to-yellow-500 w-fit rounded-r-full p-1">
          <h2 className="text-2xl">Address</h2>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-[22px] h-[22px] mt-1"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
            />
          </svg>
        </div>
        <p className="text-base  font-fancy py-3">
          RFC Pir Mahal, thana road,Madina block
        </p>
        <p className="text-base  font-fancy py-3">
          RFC Manawala near Nadra Office, GT road
        </p>
        <div className="flex justify-around">
          <a href="https://maps.app.goo.gl/A6BYRpgCpn3ekn4X9" target="_blank" rel="noreferrer">
            <button className="text-lg shadow-lg py-2 px-4 rounded-full text-transparent bg-clip-text bg-gradient-to-r from-amber-700 to-amber-300 font-fancy font-bold animate-button">
              RFC Pir Mahal
            </button>
          </a>
          <a href="https://maps.app.goo.gl/PRmEy796brDZjB679" target="_blank" rel="noreferrer">
            <button className="text-lg shadow-lg py-2 px-4 rounded-full text-transparent bg-clip-text bg-gradient-to-r from-amber-700 font-fancy font-bold to-amber-300 animate-button ">
              RFC Manawala
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default Address;
